import React from "react";
import { useLocation, useParams, Link } from "react-router-dom";
import MainContentContainer from '../../MainContentContainer/MainContentContainer';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Paper,
} from "@mui/material";
import { Save, Cancel } from "@mui/icons-material";
import AddEditBackgroundMusic from "./AddEditBackgroundMusic";

function BackgroundAddEditPage() {
  const location = useLocation();
  const { id } = useParams();
  const isEdit = location.pathname.indexOf("edit") > -1;
  const backgroundMusicRef = React.useRef();

  const handleSave = (e) => {
    e.preventDefault();
    backgroundMusicRef.current?.submit();
  };

  return (
    <MainContentContainer>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {isEdit ? "Edit Background Music" : "Create New Background Music"}
          </Typography>
          <Button
            color="error"
            component={Link}
            to="/background-musics"
            startIcon={<Cancel />}
            variant="contained"
            sx={{ marginRight: 2 }}
          >
            Cancel
          </Button>
          <Button
            color="success"
            onClick={handleSave}
            startIcon={<Save />}
            variant="contained"
          >
            {isEdit ? "Update" : "Create"}
          </Button>
        </Toolbar>
      </AppBar>
      <Box gap={4}>
        <Paper sx={{ padding: 2 }}>
          <AddEditBackgroundMusic
            ref={backgroundMusicRef}
            isEdit={isEdit}
            selectedId={id}
          />
        </Paper>
      </Box>
    </MainContentContainer>
  );
}

export default BackgroundAddEditPage;
